import { useContext } from "react";
// components
import DialogAnimate from "src/components/animate/DialogAnimate";

import Context from "../context";
import DialogFooter from "./DialogFooter";
import DialogPaper from "./DialogPaper";
import DialogTitle from "./DialogTitle";

export default function DeleteRedirectDialog() {
	const { actions, state } = useContext(Context);
	return (
		<DialogAnimate
			maxWidth='xs'
			onClose={actions.hideRemoveUriDialog}
			open={state.showRemoveUriDialog}
		>
			<DialogTitle />
			<DialogPaper />
			<DialogFooter />
		</DialogAnimate>
	);
}
